import React, { Component } from "react";
import sampleVid from "../assets/stayAwake.mp4";
import styled from "styled-components";

const StayAwakeDiv = styled.div`
    width:2px;
    height:2px;
`;

export class StayAwake extends Component {
	
	constructor(props) {
		super(props);
        this.videoElement = React.createRef();
	}

    componentDidMount() {
        this.videoElement.current.play();
    }

    render() {
		return (
			<StayAwakeDiv>
                <video ref={this.videoElement} muted={true} playsInline={true} title="NoSleepManual" loop={true}>
                    <source src={sampleVid}/>
                </video>
            </StayAwakeDiv>
		);
	}
}
